import Pie from '@/components/ui/PieChart';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

const SessionsPieChart = ({ percentageFull, title, limit, used }: { percentageFull?: number; title: string; limit?: number; used?: number }) => {
  return (
    <div className="tw-flex tw-items-start tw-gap-1 tw-px-2 tw-py-1 tw-h-full">
      <div className="tw-flex tw-items-center tw-gap-2">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
          <div className="tw-text-gray-500 lg:tw-text-xs tw-text-[9px] tw-font-['Lexend'] tw-leading-none">{title}</div>

          <div className="tw-text-gray-700 lg:tw-text-xs tw-text-[9px] tw-font-['Lexend'] tw-leading-normal ">
            {used}
            {' / '}
            {limit && limit < 0 ? <span>&#8734;</span> : <span>{limit ?? 0}</span>}
          </div>
        </div>
      </div>
      <div className="tw-w-10 tw-h-10 tw-block">
        <Pie percentageFull={percentageFull} />
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(SessionsPieChart);
